const isWcColumn = (result) => {
    if (result.element) {
        let group = result.element.parentElement;
        if (group && group.label.indexOf('WooCommerce') === 0) {
            return true;
        }
    }
    return false;
};
document.addEventListener('DOMContentLoaded', () => {
    let WcIcon = aca_wc_admin.assets + 'images/woo.svg';
    AC_SERVICES.filters.addFilter('column_type_templates', (value, pl) => {
        if (pl.result.hasOwnProperty('id') && isWcColumn(pl.result)) {
            value += `<img src="${WcIcon}" alt="WooCommerce" class="ac-column-type-icon" />`;
        }
        return value;
    }, 10);
});
export {};
